import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";

export default function GoodPeople() {
  return (
    <table className="KPIs-table">
      <tr>
        <th>Strategic Imperative</th>
        <th>KPI</th>
        <th>Unit</th>
        <th>Weight (%)</th>
        <th>
          <div>Target</div>
          <div>YTD</div>
        </th>
        <th>
          <div>Actual</div>
          <div>YTD</div>
        </th>
        <th>%Achieved</th>
        <th>Score</th>
        <th>
          <div>Actual</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Feb</div>
        </th>
        <th>
          <div>Mar</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Apr</div>
        </th>
        <th>
          <div>Actual</div>
          <div>May</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jun</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jul</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Aug</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Sep</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Oct</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Nov</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Dec</div>
        </th>
      </tr>
      <tr className="table-collapse">
        <td
          style={{
            border: "none",
            background: "#11ceae",
            whiteSpace: "nowrap",
          }}
        >
          การพัฒนาคนให้เป็นคนดีและคนเก่ง
        </td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>Employer Branding & Employee Engagement</td>
        <td>
          การดำเนินการแผน Gap closing plan เพื่อเพิ่มความผูกพันพนักงานในหน่วยงาน
        </td>
        <td>%</td>
        <td>2.5%</td>
        <td>-</td>
        <td>100%</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>100%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>Modular Organization</td>
        <td>พนักงานที่เข้าร่วม Modular organization</td>
        <td>%พนักงานที่เข้าร่วม</td>
        <td>1.0%</td>
        <td>-</td>
        <td>3%</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>3%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>Modular Organization</td>
        <td>จำนวนโครงการ Modular organization</td>
        <td>จำนวนโครงการ</td>
        <td>0.3%</td>
        <td>-</td>
        <td>5</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>5</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>Modular Organization</td>
        <td>รายได้จากการทำงานแบบ Modular organization</td>
        <td>ล้านบาท /คน</td>
        <td>1.3%</td>
        <td>74</td>
        <td>74</td>
        <td>100%</td>
        <td>3</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>74</td>
      </tr>
      <tr className="table-collapse">
        <td
          style={{
            border: "none",
            background: "#11ceae",
            whiteSpace: "nowrap",
          }}
        >
          บริษัทที่เป็นสมาชิกที่ดีของประเทศ
        </td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
        <td style={{ border: "none", background: "#11ceae" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>การตลาดอย่างรับผิดชอบผลิตสินค้าใหม่เพื่อสุขภาพ</td>
        <td>% ผลิตภัณฑ์ใหม่ที่ผลิตใหม่เพื่อสุขภาพ</td>
        <td>%</td>
        <td>0.0%</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td>-</td>
        <td></td>
        <td></td>
        <td>-</td>
        <td></td>
        <td></td>
        <td>-</td>
        <td></td>
        <td></td>
        <td>-</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>การบริหารทรัพยากรที่เป็นเลิศ</td>
        <td>ปริมาณการใช้พลังงานจากพลังงานหมุนเวียน / การใช้พลังงานทั้งหมด</td>
        <td>%</td>
        <td>2.5%</td>
        <td>-</td>
        <td>4%</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>4%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>การจัดหา (Sourcing) อย่างรับผิดชอบต่อโลก</td>
        <td>วัตถุดิบหลักสามารถตรวจสอบย้อนกลับ ได้อย่างครบถ้วน</td>
        <td>%</td>
        <td>2.5%</td>
        <td>-</td>
        <td>100%</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>100%</td>
      </tr>
    </table>
  );
}
